import React from 'react';
import './DemoBanner.css';

const DemoBanner: React.FC = () => {
  return (
    <div className="demo-banner">
      <div className="demo-banner-content">
        <span className="demo-banner-icon">🚧</span>
        <span className="demo-banner-text">
          This is a demo feature. Its purpose is to show you what we're working on. Stay tuned for regular updates!
        </span>
      </div>
    </div>
  );
};

export default DemoBanner;

